import { QueryKeys, queryClient, useEntity } from "@/api/core";
import { useGroupRelationship } from "@/api/group-relationships";
import { useLoggedIn } from "@/hooks";
import { type Group, groupSchema } from "@/schemas";

interface UseGroupOpts {
  refetch?: boolean;
  isEnabled?: boolean;
}

function useGroup(groupId?: string, opts: UseGroupOpts = {}) {
  const { refetch, isEnabled = true } = opts;
  const { queries } = queryClient.getDefaultOptions();
  const { isLoggedIn } = useLoggedIn();

  const { entity: group, ...result } = useEntity<Group>({
    queryKey: QueryKeys.groups.group(groupId!),
    endpoint: `/api/v1/groups/${groupId}`,
    schema: groupSchema,
    enabled: !!groupId && isLoggedIn && isEnabled,
    staleTime: refetch ? 0 : queries?.staleTime,
    cacheTime: refetch ? 0 : queries?.cacheTime,
    id: groupId!,
    useInitialDataAsPlaceholder: true,
  });

  const { groupRelationship, isLoading: isRelationshipLoading } =
    useGroupRelationship(groupId);

  return {
    ...result,
    isLoading: result.isLoading || isRelationshipLoading,
    group: group
      ? { ...group, relationship: groupRelationship || null }
      : undefined,
  };
}

export { useGroup };
